import { Log } from 'ng2-logger';
import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import Paginate from '../../../../../components/table/paginate';
import Announce from '../../../../../components/templates/announce';
import Translator from '../../../../../core/i18n';
import { IAction, IAppState } from '../../../../../models/action/core';
import * as Actions from '../../../../../store/actions/examSession';
import { IPagedQueryS } from '../../../../../models/components/paginate';
import { IFilterExamQuestions, IQuestions } from '../../../../../models/components/add-exam-sessions';
import { QuestionType } from '../../../../../models/enums/QuestionType';
import imgAnn from '../../../../../static/images/announcement.svg';
import { Notification } from '../../../../../components/notification/main';
import Tooltip from '../../../../../components/tooltip/main';
import { Button } from '../../../../../components/ui-elements/main';
import Truncater from '../../../../../components/truncater/main';

const T = Translator.create();
const _logger = Log.create('add session questions');

interface IQuestionsModalProps {
    currentTab: string;
    coursePageActivityId?: string;
    coursePageClassId?: string;
    examId?: string;
    examSessionId: string;
    dispatch?: any;
    questionDatas?: {
        filters: IPagedQueryS;
        results: IQuestions[] | null;
    };
    publishDatas?: any;
}

interface IQuestionsModalState {
    filters: IPagedQueryS;
    isAll: boolean;
    disAllowedQuestionIds: string[];
    selectedQuestionIds: string[];
}

export class Questions extends Component<IQuestionsModalProps, IQuestionsModalState> {
    constructor(props: any) {
        super(props);

        this.state = {
            filters: {
                page: 1,
                take: 20,
                total: 0
            },
            isAll: false,
            disAllowedQuestionIds: [],
            selectedQuestionIds: []
        };
    }

    componentDidMount = async () => {
        await this.getQuestion();
    };

    getQuestion = async () => {
        if (this.props.examSessionId && this.props.examId) {
            const filters: IFilterExamQuestions = { examSessionId: this.props.examSessionId, examId: this.props.examId };
            this.props.dispatch(Actions.ExamSessionQuestionList(filters, this.state.filters, '', 'get'));
        }
    };

    onPageChange = async (page: number) => {
        this.state.filters.page = page;
        this.setState(this.state);
        await this.getQuestion();
    };

    selectAll = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event && event.target) {
            this.setState({ isAll: event.target.checked });
            if (!event.target.checked) {
                this.setState({ disAllowedQuestionIds: [] });
            }
        }
    };

    onSelectQuestion = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event && event.target) {
            if (!this.state.isAll) {
                const selectedIds = Object.assign([], this.state.selectedQuestionIds);
                const id: string = event.currentTarget.dataset.id || '';
                if (event.target.checked && id) {
                    selectedIds.push(id);
                } else if (!event.target.checked && id) {
                    const index = selectedIds.indexOf(id);
                    if (index !== -1) {
                        selectedIds.splice(index, 1);
                    }
                }
                this.setState({ selectedQuestionIds: selectedIds });
            } else {
                const disAllowedIds = Object.assign([], this.state.disAllowedQuestionIds);
                const id: string = event.currentTarget.dataset.id || '';
                if (!event.target.checked && id) {
                    disAllowedIds.push(id);
                } else if (event.target.checked && id) {
                    const index = disAllowedIds.indexOf(id);
                    if (index !== -1) {
                        disAllowedIds.splice(index, 1);
                    }
                }
                this.setState({ disAllowedQuestionIds: disAllowedIds });
            }
        }
    };

    deleteSelectedQuestions = () => {
        if (
            this.props.publishDatas!.activeStatus === 0 &&
            this.props.publishDatas!.isPassive === 1
        ) {
            if (
                this.props.examSessionId &&
                this.props.examId &&
                ((this.state.selectedQuestionIds && this.state.selectedQuestionIds.length) || this.state.isAll)
            ) {
                this.props.dispatch(
                    Actions.ExamSessionDeleteQuestion(
                        this.state.isAll,
                        this.props.examSessionId,
                        this.props.examId,
                        this.state.selectedQuestionIds,
                        this.deleteSelectedQuestionsCallBack,
                        this.state.disAllowedQuestionIds,
                        '',
                        'get'
                    )
                );
            }
        } else {
            Notification.setNotification('error', T.t('r_activity_exam_session_edit_error').replace('{0}', T.t('r_activity_exam_session_edit_error_questions')), 'topRight');
        }
    };

    deleteSelectedQuestionsCallBack = async () => {
        await this.getQuestion().then(() => {
            this.setState({
                selectedQuestionIds: [],
                disAllowedQuestionIds: [],
                isAll: false
            });
            this.props.dispatch(Actions.ExamSessionAddQuestionListDefault('', 'get'));
            if (this.props.coursePageActivityId && this.props.coursePageClassId && this.props.examId && this.props.examSessionId) {
                this.props.dispatch(
                    Actions.ExamSessionListGetAction(
                        this.props.examId,
                        this.props.coursePageActivityId,
                        this.props.coursePageClassId,
                        '',
                        'get',
                        this.props.examSessionId
                    )
                );
                this.props.dispatch(Actions.ExamSessionPublishDatas(this.props.examId, this.props.examSessionId, '', 'get'));
            }
        });
    };

    public render() {
        return (
            <div
                className={'tab-pane fade' + (this.props.currentTab === '_sessionQuestions' ? ' show active' : '')}
                style={{ width: '100%' }}
                role="tabpanel"
                aria-labelledby="all-users-tab"
            >
                <div className="container">
                    <div className="question-list mt-3">
                        {this.props.questionDatas && this.props.questionDatas.results && this.props.questionDatas.results.length > 0 && (
                            <div className="no-hover question-row align-items-baseline">
                                <div className="tick-radio position-relative">
                                    <input
                                        onChange={this.selectAll}
                                        type="checkbox"
                                        checked={this.state.isAll}
                                        name="demo"
                                        defaultValue="one"
                                        id="radio-three"
                                        className="form-radio mr-2"
                                    />
                                    <span style={{ color: '#abaaa7' }}>{T.t('r_select_all')}</span>
                                </div>
                                {this.props.questionDatas &&
                                this.props.questionDatas.results &&
                                this.props.questionDatas.results.length > 0 &&
                                ((this.state.selectedQuestionIds && this.state.selectedQuestionIds.length) || this.state.isAll) ? (
                                    <div className="row justify-content-end mt-3 ">
                                        <Button
                                            button_type='secondary'
                                            onClick={this.deleteSelectedQuestions}
                                            size='medium'
                                            text={T.t('r_gen_exam_session_delete_question')}
                                            iconPosition='left'
                                            materialicon='delete'
                                        />
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>
                        )}
                        {this.props.questionDatas && this.props.questionDatas.results && this.props.questionDatas.results.length ? (
                            this.props.questionDatas.results.map((item: IQuestions) => {
                                return (
                                    <div key={item.questionId} className="question-row">
                                        <div className="tick-radio position-relative">
                                            {item.alreadyUsed ? (
                                                <>
                                                    <Tooltip data={T.t('r_gen_exam_session_question_already_user')} position='top'>
                                                        <i className="material-icons mr-2" style={{ width: 20, height: 20, fontSize: 20 }}>
                                                            info
                                                        </i>
                                                    </Tooltip>

                                                    <input className="form-radio" style={{ display: 'none' }} />
                                                </>
                                            ) : (
                                                <input
                                                    data-id={item.questionId}
                                                    onChange={this.onSelectQuestion}
                                                    type="checkbox"
                                                    name="demo"
                                                    defaultValue="one"
                                                    id="radio-three"
                                                    checked={
                                                        (!this.state.isAll && this.state.selectedQuestionIds.includes(item.questionId)) ||
                                                        (this.state.isAll && !this.state.disAllowedQuestionIds.includes(item.questionId))
                                                    }
                                                    className="form-radio mr-2"
                                                />
                                            )}

                                            <Tooltip data={item.questionText} position='top'>
                                                <Truncater text={item.questionText} length={72}>
                                                    <label
                                                       dangerouslySetInnerHTML={{ __html: item.questionText }}
                                                    />
                                                </Truncater>
                                            </Tooltip>
                                        </div>
                                        <div className="row-options">
                                            <div className="d-flex align-items-end justify-content-end" style={{ minWidth: 204, maxWidth: 204 }}>
                                            {item.difficulty && (
                                                        <Tooltip data={T.t('r_exam_difficulty_' + item.difficulty.replace(' ', ''))} position='top'>
                                                         <Button
                                                             button_type='secondary'
                                                             size='small'
                                                             text={T.t('r_exam_difficulty_' + item.difficulty.replace(' ', ''))}
                                                         />
                                                         </Tooltip>
                                                     )}
                                                     {item.questionCategories && item.questionCategories !== ' ' && (
                                                        <Tooltip data={item.questionCategories} position='top'>
                                                         <Button
                                                             button_type='secondary'
                                                             size='small'
                                                             text={item.questionCategories.length > 25 ? item.questionCategories.substring(0, 25) + '...' : item.questionCategories}
                                                         />
                                                         </Tooltip>
                                                     )}
                                                     {item.topics && (
                                                            <Tooltip data={item.topics} position='top'>
                                                         <Button
                                                             button_type='secondary'
                                                             size='small'
                                                             text={item.topics.length > 20 ? item.topics.substring(0, 20) + '...' : item.topics}
                                                         /></Tooltip>
                                                     )}
                                                     <Tooltip data={T.t('r_question_type_' + QuestionType[item.questionType].toString())} position='top'>
                                                     <Button
                                                         button_type='secondary'
                                                         size='small'
                                                         text={T.t('r_question_type_' + QuestionType[item.questionType].toString()).length > 25
                                                             ? T.t('r_question_type_' + QuestionType[item.questionType].toString()).substring(0, 25) + '...'
                                                             : T.t('r_question_type_' + QuestionType[item.questionType].toString())}
                                                     /></Tooltip>


                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <Announce
                                title={T.t('r_no_record_found')}
                            >
                                        <img src={imgAnn} />
                                        <h5 style={{ marginTop: 15, marginBottom: 50 }}>{T.t('r_gen_exam_session_question_not_found')}</h5>
                            </Announce>
                        )}

                        {this.props.questionDatas && this.props.questionDatas.results && this.props.questionDatas.results.length > 0 && (
                            <div className="row-options justify-content-end">
                                <div
                                    className="page-sorting d-flex align-items-center justify-content-center"
                                    style={{ marginTop: '5px' }}
                                />
                                <Paginate
                                    class={'custom-paginate'}
                                    filters={this.props.questionDatas.filters}
                                    onPageChange={this.onPageChange}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IQuestionsModalProps): IQuestionsModalProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IQuestionsModalProps = Object.assign({}, ownProps, {
        questionDatas: state.examSession.questionDatas,
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        publishDatas: state.examSession.publishDatas
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return (
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.examSession.questionDatas === prev.examSession.questionDatas &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.examSession.publishDatas === prev.examSession.publishDatas
    );
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CQuestions = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(Questions);

export default CQuestions;
